export {};

$(groupStructure);

NLMK.groupStructure = groupStructure;

function groupStructure() {
    const $structures = $('.accordion--group-structure');
    const $firstParentLeft = $structures.filter('[data-parent="left"]');
    const $firstParentRight = $structures.filter('[data-parent="right"]');
    const $lastChildLeft = $structures.filter('[data-child="left"]').last();
    const $lastChildRight = $structures.filter('[data-child="right"]').last();

    $firstParentLeft.attr('data-chain-left', 'left-start');
    $firstParentRight.attr('data-chain-right', 'right-start');

    $lastChildLeft.attr('data-chain-left', 'left-end');
    $lastChildRight.attr('data-chain-right', 'right-end');

    let leftEmpty = true;
    let rightEmpty = true;
    $structures.each(function () {
        const $item = $(this),
            child = $item.data('child'),
            leftState = $item.data('chain-left'),
            rightState = $item.data('chain-right');

        if(leftState === 'left-start') {
            leftEmpty = false;
        } else if(leftState === 'left-start') {
            leftEmpty = true;
        } else if(child !== 'left') {
            $item.attr('data-chain-left', leftEmpty?'empty':'');
        }

        if(rightState === 'right-start') {
            rightEmpty = false;
        } else if(rightState === 'right-start') {
            rightEmpty = true;
        } else if(child !== 'right') {
            $item.attr('data-chain-right', rightEmpty?'empty':'');
        }

    });

    $('.your-slider').on('afterChange', function() {
        const currentColor = $('.slick-current').data('btn-color');
        const $btn = $('.btn');

        $btn.addClass(currentColor);
    });
}



// WEBPACK FOOTER //
// ./js/main/module/group-structure.js